import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import productCategoryService from "services/ProductsCatService";

export const getAllProductCategoriesForAdminSchool = createAsyncThunk(
	"productCategory/getAllForAdminSchool",
	async (_, { rejectWithValue }) => {
		try {
			const response = await productCategoryService.getAllForAdminSchool();
			return response?.data;
		} catch (error) {
			return rejectWithValue(error.response || "Erreur");
		}
	}
);

export const createProductCategory = createAsyncThunk(
	"productCategory/create",
	async ({ category }, { rejectWithValue }) => {
		try {
			const response = await productCategoryService.createProductCategory({
				category,
			});
			return response?.data;
		} catch (error) {
			console.log(error);
			return rejectWithValue(error.response || "Erreur");
		}
	}
);

const initialState = {
	productCategories: [],
	productCategory: null,
	loading: false,
	error: null,
};

const productCategorySlice = createSlice({
	name: "productCategory",
	initialState,
	reducers: {
		setProductsCategories: (state, action) => {
			state.productCategories = action.payload;
		},

		setProductsCategory: (state, action) => {
			state.productCategory = action.payload;
		},
	},
	extraReducers: {
		[getAllProductCategoriesForAdminSchool.pending]: (state) => {
			state.loading = true;
		},

		[getAllProductCategoriesForAdminSchool.fulfilled]: (state, { payload }) => {
			state.productCategories = payload.data;
			state.loading = false;
		},

		[getAllProductCategoriesForAdminSchool.rejected]: (state) => {
			state.loading = false;
		},
		[createProductCategory.pending]: (state) => {
			state.loading = true;
		},
		[createProductCategory.fulfilled]: (state, { payload }) => {
			state.loading = false;
			state.productCategories.push(payload);
		},
		[createProductCategory.rejected]: (state) => {
			state.loading = false;
		},
	},
});

export const { setProductCategories, setProductCategory } =
	productCategorySlice.actions;

export default productCategorySlice.reducer;
